const { h, render, Component } = require('preact');

class Divider extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <hr class="divider refund"/>
    )
  }
}

module.exports = Divider
